// extracted by mini-css-extract-plugin
export default {"footerFinca":"style_footerFinca__wBwaG","itemsFooter":"style_itemsFooter__sSrD6","iconsFooter":"style_iconsFooter__N6LzP","footerLogo":"style_footerLogo__ix669"};